// extracted by mini-css-extract-plugin
module.exports = {"title":"menuItem-module--title--2OtAj typography-module--responsiveTitle2--2mJ1S","PostSubTitle":"menuItem-module--PostSubTitle--Rm3IR typography-module--responsiveTitle3--jox9w"};